import { render } from "./MemoryGame.vue?vue&type=template&id=02923d62&scoped=true"
import script from "./MemoryGame.vue?vue&type=script&lang=js"
export * from "./MemoryGame.vue?vue&type=script&lang=js"

import "./MemoryGame.vue?vue&type=style&index=0&id=02923d62&scoped=true&lang=css"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02923d62"]])

export default __exports__